var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPortabilityIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 14,
    viewBox: "0 0 13 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_707_3076)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.54677 10.7623V10.8508C3.68264 10.7692 2.86944 10.3892 2.25052 9.77027C1.6316 9.15135 1.25163 8.33816 1.16996 7.47402H1.25851C1.33989 8.31473 1.71047 9.10557 2.31285 9.70795C2.91522 10.3103 3.70606 10.6809 4.54677 10.7623ZM1.25851 6.76889H1.16996C1.25163 5.90475 1.6316 5.09156 2.25052 4.47264C2.86944 3.85372 3.68264 3.47374 4.54677 3.39208V3.48062C3.70606 3.562 2.91522 3.93259 2.31285 4.53496C1.71047 5.13734 1.33989 5.92818 1.25851 6.76889ZM5.11765 2.64213L5.17963 2.58015L5.26981 2.67033H5.14586L5.11765 2.64213ZM7.70195 11.5726H7.8259L7.8541 11.6008L7.79213 11.6628L7.70195 11.5726ZM10.7212 9.77027C10.1023 10.3892 9.28912 10.7692 8.42498 10.8508V10.7623C9.26569 10.6809 10.0565 10.3103 10.6589 9.70795C11.2613 9.10557 11.6319 8.31473 11.7132 7.47402H11.8018C11.7201 8.33816 11.3402 9.15135 10.7212 9.77027ZM11.8018 6.76889H11.7132C11.6319 5.92818 11.2613 5.13734 10.6589 4.53496C10.0565 3.93259 9.26569 3.562 8.42498 3.48062V3.39208C9.28912 3.47374 10.1023 3.85372 10.7212 4.47264C11.3402 5.09156 11.7201 5.90475 11.8018 6.76889Z",
    fill: "black",
    stroke: "#FF7A00",
    strokeWidth: 0.705128
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_707_3076"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12.6923,
    height: 12.6923,
    fill: "white",
    transform: "translate(0.140625 0.775391)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPortabilityIcon);
export default __webpack_public_path__ + "static/media/portabilityIcon.c27c533633c528d62317924409247c10.svg";
export { ForwardRef as ReactComponent };